import env from '#shared/config/env.js';

/**
 * Return an array of available payment methods for current cart provider with additional details
 * @param {object} options
 * @param {object} options.provider
 * @param {string} options.provider.name
 * @param {object[]} options.provider.paymentMethods
 * @param {string[]} options.customIDs
 * @returns {object[]}
 */
export default ({ provider, customIDs = [] }) => {
	const providerName = provider.name;
	return (provider.paymentMethods || []).filter((paymentMethod) => {
		// Disable PayPal payment method with customID
		if (paymentMethod.id === 'payPalBilling' && customIDs.includes('PAYPALOFF')) {
			return false;
		}
		// Return enabled only payment method or force-enable with customID
		return customIDs.includes('PMSHOW') || paymentMethod.isEnabled;
	}).map((paymentMethod) => ({
		...paymentMethod,
		isTrial: env.trialMethods[providerName].includes(paymentMethod.id),
		isOffline: env.offlineMethods[providerName].includes(paymentMethod.id),
		isManualRenewal: env.manualRenewalMethods[providerName].includes(paymentMethod.id),
		isOms: env.omsMethods[providerName].includes(paymentMethod.id),
		isCompany: env.companyMethods[providerName].includes(paymentMethod.id),
		isRedirectable: env.redirectMethods[providerName].includes(paymentMethod.id),
		isLibrarySkippable: env.librarySkippableMethods[providerName].includes(paymentMethod.id),
		hasFixedCountry: env.fixedCountryMethods[providerName].includes(paymentMethod.id),
		hasInstallmentsAvailable: env.installmentsMethods[providerName].includes(paymentMethod.id),
		label: `paymentMethod_${paymentMethod.id}`
	}));
};
